import { Injectable, inject } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { AuthService } from '../services/auth/auth.service'

// nomeTela registrado no backend pra essa tela é 'portal-fornecedor' — mesmo padrão
// de permissão do resto do sistema (nomeFuncao == 'Paginado' libera o acesso).
const SUPPLIER_PORTAL_SCREEN = 'portal-fornecedor'

@Injectable({
  providedIn: 'root',
})
export class SupplierPortalGuard implements CanActivate {
  private router = inject(Router)
  private authService = inject(AuthService)

  canActivate(): boolean {
    if (!this.authService.checkPermission('paginado', SUPPLIER_PORTAL_SCREEN)) {
      this.router.navigate(['/home'])
      return false
    }

    return true
  }
}
